module.exports = __webpack_public_path__ + "static/media/campanha-rafamattos.0b9a99ee.jpg";